// Le Radar : la scène, ses calques, la fiche d'un sujet, d'un public, d'un
// rendez-vous ; et ce qui s'y ouvre (les personas d'une audience, une écoute,
// le moment où l'on parle à un persona, la fiche d'un persona V2).
export default {
  sousTitre: 'Vos {n} territoires observés : ce qui monte auprès d’eux, ce qui vient',
  chargement: 'Le radar se lit…',
  erreurLecture: 'Le radar n’a pas pu se lire.',
  aucunTerritoire: 'Aucun territoire n’est encore ouvert à votre compte.',
  aucunTerritoireSuite: 'Dès qu’un administrateur en ouvre, ils apparaissent ici.',
  calques: {
    aria: 'Les calques',
    chaines: 'Chaînes',
    vod: 'VOD et streaming',
    sociales: 'Plateformes sociales',
    verticales: 'Verticales',
    jeunes: 'Publics jeunes',
    politique: 'Politique',
  },
  recoupements: {
    bouton: 'Recoupements d’audience',
    aria: 'Recoupements mesurés sur',
    parSujets: 'par sujets',
    parPersonas: 'par personas',
    enCommun: 'en commun',
    legendePersonas: 'deux publics qui partagent les mêmes personas',
    legendeSujets: 'deux publics qui parlent des mêmes sujets',
  },
  vue: {
    aria: 'La vue',
    publics: 'Les publics',
    pays: 'Les pays · {n}',
  },
  scene: {
    aria: 'La scène',
    voirCarte: '{pays} : voir la carte des pays',
    paysDe: 'le pays de',
    vosPublics: 'vos publics',
    puceSujetsNeufs: '{nom}, {n} sujets neufs',
    retirerSelection: 'Retirer la sélection',
    publicsObserves: '{n} publics observés',
    sujetsMontent: '{n} sujets montent auprès d’eux',
    rienNeMonte: 'rien ne monte encore auprès d’eux',
    pastillePublics: '{n} publics',
    legendeSujetsNeufs: 'des sujets neufs auprès de ce public',
    legendeBientot: 'bientôt observé',
    legendeCombien: 'combien de sujets neufs',
    legendeFormat: 'leur public parle de l’un de vos formats',
  },
  carte: {
    aria: 'Vos pays',
    enOrbite: '{n} publics en orbite · revenir aux publics',
    vosPays: 'Vos {n} pays',
  },
  liste: {
    monteDansPays: 'Ce qui monte dans vos pays',
    monteAupresPublics: 'Ce qui monte auprès de vos publics',
    politique: 'politique',
    publics: '{n} public | {n} public | {n} publics',
    jours: '{n} jour | {n} jour | {n} jours',
    rien: 'Rien ne remonte encore chez ces publics.',
    aVenirPays: 'À venir dans vos pays',
    aVenirPublics: 'À venir auprès de vos publics',
  },
  votreFormat: 'votre format',
  votreFormatChez: 'votre format · {chaine}',
  votreFormatTitre: 'votre format : {titre}',
  tousLesSujets: 'Tous les sujets',
  ficheSeLit: 'La fiche se lit…',
  evenement: {
    types: {
      audience: 'Audience',
      frequentation: 'Fréquentation',
      achat: 'Achat',
      pratique: 'Pratique',
      opinion: 'Opinion',
      vote: 'Vote',
      autre: 'Projection',
    },
    question: '« {question} »',
    le: ', le {jour}',
    detail: 'Détail',
    bandeAges: '{de}-{a} ans',
    bandeAgesPlus: '{de} ans et plus',
    genres: {
      Femmes: 'Femmes',
      Hommes: 'Hommes',
    },
    sansPanel: 'Rien à demander à une population sur ce rendez-vous.',
    sansPanelRaison: 'Rien à demander à une population sur ce rendez-vous : {raison}',
    panelRepond: 'Le panel du public de {nom} répond.',
    projectionSePrepare: 'La projection se prépare.',
    avecStimulus: 'Avec « {titre} »',
    votreStimulus: 'votre stimulus',
    effetStimulus: '{pts} avec le stimulus',
    stimulusEchec: 'Le panel n’a pas pu voir ce stimulus : essayez une image ou un texte.',
    panelRegarde: 'Le panel regarde, puis répond.',
    etudeSePrepare: 'L’étude se prépare, elle part dans l’heure.',
    simulation: 'La simulation',
    bornesScenarios: '{bas} % ~ {haut} %',
    bornesDeA: 'de {bas} à {haut} %',
  },
  approfondir: {
    ouvrir: 'Approfondir avec un visuel, une vidéo ou un texte',
    choisirFichier: 'Choisir un fichier',
    ariaForme: 'Ce qu\'on montre',
    formes: {
      image: 'Image',
      video: 'Vidéo',
      texte: 'Texte',
    },
    adresseImage: 'ou l’adresse d’une image',
    adresseVideo: 'ou l’adresse d’une vidéo (YouTube compris)',
    textePlaceholder: 'Le texte que le panel lira : un pitch, une accroche, un communiqué',
    nomPlaceholder: 'Son nom (pour vous)',
    jumeaux: 'Jumeaux',
    envoi: 'Envoi…',
    lancer: 'Lancer l’approfondissement',
    annuler: 'Annuler',
    erreurTexte: 'Écrivez le texte que le panel lira.',
    erreurImage: 'Déposez une image ou collez son adresse.',
    erreurVideo: 'Déposez une vidéo ou collez son adresse (YouTube compris).',
    erreurEnvoi: 'L’approfondissement n’a pas pu partir.',
    titreVisuel: 'Visuel',
    titreVideo: 'Vidéo',
  },
  sujet: {
    publics: '{n} de vos publics',
    joursAffilee: '{n} jours d’affilée',
    mentions: '{n} mention | {n} mention | {n} mentions',
    mentionsChez: '{mentions} chez {n} de vos publics',
    mentionsDuAu: '{mentions} chez {n} de vos publics, du {du} au {au}',
    ouRessort: 'Les publics où il ressort le plus',
    quiEnParle: 'Qui en parle :',
    ageMedian: 'âge médian {n} ans',
    sentimentTerritoires: 'Sentiment des territoires',
    sentimentTerritoire: 'Sentiment du territoire',
    etAutres: '{noms} et {n} autres | {noms} et {n} autre | {noms} et {n} autres',
    etDernier: '{noms} et {dernier}',
    favorables: 'favorables',
    neutres: 'neutres',
    defavorables: 'défavorables',
    polariteAria: '{f} % favorables, {m} % neutres, {d} % défavorables',
    sansAvis: 'Personne n’y met encore d’avis tranché : on en parle, sans pour ni contre.',
    sentimentSeLit: 'Le sentiment se lit.',
    sentimentGlobal: 'Sentiment global',
    origineEnLigne: 'les gens qui parlent de « {sujet} » en ligne',
    sansAvisEnLigne: 'Personne n’y met encore d’avis tranché en ligne.',
    ceQueCest: 'Ce que c’est',
    publie: 'Publié :',
    selon: '{valeur} selon {source}',
    projete: 'projeté {x}',
    sesPersonas: 'Ses personas',
    explorer: 'Explorer',
    poserQuestion: 'Poser la question au panel',
  },
  public: {
    familles: {
      france: 'Pays',
      pays: 'Pays',
      ville: 'Métropole',
      region: 'Région',
      chaine: 'Chaîne',
      vod: 'VOD et streaming',
      sociale: 'Plateforme sociale',
      plateforme: 'Plateforme',
      jeunes: 'Public jeune',
      thematique: 'Public thématique',
      politique: 'Territoire politique',
    },
    groupes: {
      tf1: 'groupe TF1',
      ftv: 'France Télévisions',
      m6: 'groupe M6',
      canal: 'groupe Canal+',
      arte: 'Arte',
      amaury: 'groupe Amaury',
      rmcbfm: 'RMC BFM',
      lcp: 'chaînes parlementaires',
    },
    familleChaine: 'Chaîne · {groupe}',
    familleStreaming: 'Streaming · {groupe}',
    bientotObserve: 'Bientôt observé',
    observe: 'Observé',
    observeSujets: 'Observé · {n} sujets neufs | Observé · {n} sujet neuf | Observé · {n} sujets neufs',
    partAudience: 'Part d’audience, {mois}',
    quiLeRegarde: 'Qui le regarde',
    origine: 'le public de {nom}',
    questions: {
      regardes: 'Qu’est-ce que tu regardes sur {nom} ?',
      zapper: 'Qu’est-ce qui te ferait zapper ?',
      manque: 'Qu’est-ce qui te manque à la télé en ce moment ?',
    },
    monte: 'Ce qui monte auprès de son public',
    premiersSujets: 'Ses premiers sujets arrivent bientôt.',
    recoupe: 'Son audience recoupe',
    createurs: 'Ses créateurs de référence',
    ficheDiffuseur: 'Sa fiche diffuseur',
    tester: 'Tester un format',
  },
  mouvement: {
    installe: 'S’installe',
    monte: 'Monte',
    nouveau: 'Nouveau',
  },
  nombre: {
    pc: '{v} %',
    points: '{v} pt',
  },
  deuxPoints: '{x} :',
  guillemets: '« {x} »',
  personas: {
    erreur: 'Les personas n’ont pas pu se lire.',
    seDessinent: 'Les personas se dessinent…',
    sources: {
      territoire: 'Construits à partir de l’intelligence d’Orion, dont {n} études et sources. | Construits à partir de l’intelligence d’Orion, dont {n} étude ou source. | Construits à partir de l’intelligence d’Orion, dont {n} études et sources.',
      panel: 'Construits à partir des réponses du panel et de l’intelligence d’Orion, dont {n} études et sources sur ses publics. | Construits à partir des réponses du panel et de l’intelligence d’Orion, dont {n} étude ou source sur ses publics. | Construits à partir des réponses du panel et de l’intelligence d’Orion, dont {n} études et sources sur ses publics.',
      ecoute: 'Construits à partir de l’intelligence d’Orion, dont {n} publications relevées en ligne. | Construits à partir de l’intelligence d’Orion, dont {n} publication relevée en ligne. | Construits à partir de l’intelligence d’Orion, dont {n} publications relevées en ligne.',
    },
    voirFiche: 'Voir la fiche de {prenom}',
    suitAussiPublic: 'Son public suit aussi',
    titreFiche: 'Persona · {prenom}',
    duPublic: '{part} % du public',
    parler: 'Lui parler',
    attentes: 'Ses attentes',
    freins: 'Ses freins',
    habitudes: 'Ses habitudes',
    vocabulaire: 'Son vocabulaire',
    suitAussi: 'Suit aussi',
    consommation: 'Sa consommation',
    formatPrefere: 'format préféré',
    sonMoment: 'son moment',
    partage: 'Partage : {x}',
    univers: 'Son univers',
    panier: 'Son panier',
    achete: 'Achète :',
    marques: 'Ses marques :',
    panierMoyen: 'panier moyen',
    declencheur: 'Déclencheur : {x}',
    horsEcran: 'Hors écran',
  },
  personaDetail: {
    core: 'core',
    partAudience: 'part d\'audience',
    confiance: 'confiance',
    jtbd: 'Job to be done',
    tension: 'Tension principale',
    portraitSignal: 'Portrait signal',
    contenu: 'Contenu - mesuré sur les signaux',
    vocabulaire: 'Vocabulaire',
    chainesSuivies: 'Chaînes suivies',
    infere: 'inféré',
    affinite: 'affinité {n} %',
    comptesSuivis: 'Comptes suivis',
    consommation: 'Consommation',
    formatPrefere: 'format préféré',
    fenetre: 'fenêtre d\'engagement',
    partageVia: 'Partage via {x}',
    parasocial: 'signal parasocial {n} %',
    moments: 'Moments par plateforme',
    univers: 'Univers culturel',
    jeux: 'Jeux :',
    musique: 'Musique :',
    createurs: 'Créateurs adjacents :',
    comportement: 'Comportement d\'achat',
    categories: 'Catégories :',
    affinitesMarques: 'Affinités marques :',
    probaMerch: 'probabilité d\'achat merch',
    panierEstime: 'panier moyen estimé',
    declencheur: 'Déclencheur : {x}',
    canal: 'canal {x}',
    horsEcran: 'Hors écran :',
    stretch: 'Affinités de stretchability',
    euros: '{v} €',
  },
  ecoute: {
    enCours: 'Observation en cours.',
    questions: {
      penses: 'Qu’est-ce que tu en penses, franchement ?',
      avis: 'Qu’est-ce qui te ferait changer d’avis ?',
      avecQui: 'Tu en parles avec qui ?',
    },
    ecouter: 'Écouter sur les plateformes',
    rienDeLisible: 'Rien de lisible sur les plateformes pour l’instant.',
    reecouter: 'Réécouter',
    quatreR: {
      reach: { libelle: 'Reach', sens: 'Combien de personnes différentes en parlent, et sur combien de plateformes.' },
      resonance: { libelle: 'Resonance', sens: 'Le ton de ce qui s’en dit : plus il est positif, plus le score monte.' },
      retention: { libelle: 'Retention', sens: 'Ceux qui reviennent en parler, message après message : la fidélité.' },
      relevance: { libelle: 'Relevance', sens: 'La trajectoire : le score monte-t-il ou baisse-t-il d’une période à l’autre.' },
    },
  },
  moments: {
    titre: 'Moment',
    matin: 'Matin',
    midi: 'Midi',
    trajet: 'Trajet',
    soiree: 'Soirée',
    tard: 'Tard',
    weekendMatin: 'Week-end matin',
    weekendSoir: 'Week-end soir',
    libre: 'Libre',
    placeholder: 'Pendant un live Twitch, vendredi 23 h',
  },
}
